import { close, open } from '../../slices/modal';
import * as modals from '../../../components/ModalManager/modals';
import { trackModalOpen } from '../../../utils/analyticsEvents';

export const closeModal = () => close();

export const openModal = (
  type: keyof typeof modals,
  props: Record<string, unknown>,
) =>
  (() => {
    trackModalOpen(String(type));
    return open({
      modalType: type,
      modalProps: props,
    });
  })();
